module.exports = __webpack_public_path__ + "img/unnamed.b6dd6c53.jpg";